import React, { useEffect, useRef } from 'react';
// react-icons import는 유지합니다.
import { BiLeaf, BiCheckDouble, BiSolidWinkSmile } from 'react-icons/bi';
// GSAP 및 ScrollTrigger import 추가
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// ScrollTrigger 플러그인 등록
gsap.registerPlugin(ScrollTrigger);

// 아이콘 컴포넌트들은 그대로 유지합니다.
const LeafIcon = () => (
  <BiLeaf size={24} style={{ color: 'currentColor' }} />
);
const CheckIcon = () => (
  <BiCheckDouble size={24} style={{ color: 'currentColor' }} />
);
const SmileIcon = () => (
  <BiSolidWinkSmile size={24} style={{ color: 'currentColor' }} />
);

function WhyChooseUs() {
  const itemsRef = useRef([]); // 각 why-item 요소를 위한 ref 배열
  const sectionRef = useRef(null); // 섹션 전체 ref (선택 사항)

  useEffect(() => {
    // 유효한 요소만 필터링
    const whyItems = itemsRef.current.filter(el => el);

    whyItems.forEach((item) => {
      // 각 아이템 내부의 자식 요소들 선택 (아이콘과 텍스트 포함 div)
      const icon = item.querySelector('svg'); // react-icons가 svg로 렌더링된다고 가정
      const textDiv = item.querySelector('div'); // 아이콘 옆의 텍스트 감싸는 div

      // GSAP 타임라인 생성
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: item,
          start: 'top 85%',
          end: 'bottom 20%',
          toggleActions: 'play none none reverse', // 화면 벗어나면 반대로 재생
          // markers: true,
        }
      });

      // 타임라인에 애니메이션 추가
      tl.fromTo(item,
        { opacity: 0.7, scale: 0.9 }, // 약간 투명하고 작게 시작
        { opacity: 1, scale: 1, duration: 0.5, ease: 'power1.out' }, // 부드럽게 나타남
      )
        .fromTo([icon, textDiv], // 아이콘과 텍스트 div를 순차적으로 애니메이션
          { // 시작 상태
            opacity: 0,
            y: 25, // 약간 아래에서 시작
          },
          { // 종료 상태
            opacity: 1,
            y: 0,
            duration: 0.5, // 각 요소 애니메이션 시간
            ease: 'power2.out',
            stagger: 0.1, // 0.1초 간격으로 시작 (아이콘 먼저, 다음 텍스트 div)
          },
          "-=0.3" // 이전 애니메이션과 약간 겹치게 시작
        );
    });

    // Cleanup 함수
    return () => {
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    };
  }, []); // 마운트 시 한 번만 실행

  return (
    <section id="why-us" ref={sectionRef}>
      <div className="container">
        <h2>왜 맑은뷰연구소일까요?</h2>
        <div className="why-choose-us-grid">
          {/* 각 아이템 div에 고유 클래스 추가 */}
          <div className="why-item why-item-check" ref={(el) => (itemsRef.current[0] = el)}>
            <CheckIcon />
            <div>
              <h3>믿을 수 있는 품질</h3>
              <p>오랜 경험과 전문 장비를 사용하여 얼룩 없이 맑고 투명한 결과물을 보장합니다.</p>
            </div>
          </div>
          <div className="why-item why-item-smile" ref={(el) => (itemsRef.current[1] = el)}>
            <SmileIcon />
            <div>
              <h3>합리적인 가격</h3>
              <p>정직하고 투명한 견적으로 최고의 가성비를 제공하기 위해 노력합니다.</p>
            </div>
          </div>
          <div className="why-item why-item-leaf" ref={(el) => (itemsRef.current[2] = el)}>
            <LeafIcon />
            <div>
              <h3>안전하고 친환경적인 방법</h3>
              <p>인체와 환경에 무해한 친환경 세제 사용을 우선으로 생각합니다.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default WhyChooseUs;